/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsshareeventsend3Inputs */

const en_groupsshareeventsend3 = /** @type {(inputs: Groupsshareeventsend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const de_groupsshareeventsend3 = /** @type {(inputs: Groupsshareeventsend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Groupsshareeventsend3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsshareeventsend3 = /** @type {((inputs?: Groupsshareeventsend3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsshareeventsend3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsshareeventsend3(inputs)
	return de_groupsshareeventsend3(inputs)
});
export { groupsshareeventsend3 as "groupsShareEventSend" }